import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { BackgroundImage } from 'components/Image/BackgroundImage';
import { ga } from 'helpers/multitrack';
import { segment } from 'helpers/segment';
import { StarRating } from '../StarRating/StarRating';
import css from './VenueListItem.scss';

export const VenueListItem = ({
  type,
  activities,
  imageUrl,
  name,
  subtitle,
  hood,
  alias,
  rating,
  venueId,
  onClick,
  nolink,
  showRatingNumber = true,
  count,
}) => {
  const className = `${css.base}${type === 'no-image' ? ` ${css.hasNoImage}` : ''}`;
  const venueContent = (
    <div>
      {type !== 'no-image' && <BackgroundImage backgroundClass={css.backgroundImage} url={imageUrl} />}
      <h5 className="mb--">
        {name}
        {subtitle && ` – ${subtitle}`}
      </h5>
      <div className="mb-">
        {rating >= 0 && <StarRating showRatingNumber={showRatingNumber} rating={rating} count={count} />}
      </div>
      {hood && <p className="mb-">{hood}</p>}
      {activities && <p className="text--light">{activities.split(',')[0].trim()}</p>}
    </div>
  );
  const onVenueClick = () => {
    segment.track(`${type} Click`, {
      category: 'Venue Details',
      label: name,
    });
    ga('Venue Details', `${type} Click`, name);
  };

  if (nolink) {
    return React.cloneElement(venueContent, {
      className,
    });
  }

  return onClick ? (
    React.cloneElement(venueContent, {
      onClick: () => onClick(venueId),
      className,
    })
  ) : (
    <Link className={className} onClick={onVenueClick} to={`/studios/${alias}`}>
      {venueContent}
    </Link>
  );
};

VenueListItem.propTypes = {
  type: PropTypes.string,
  venueId: PropTypes.number.isRequired,
  activities: PropTypes.string,
  imageUrl: PropTypes.string,
  name: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  hood: PropTypes.string,
  alias: PropTypes.string.isRequired,
  rating: PropTypes.number,
  onClick: PropTypes.func,
  nolink: PropTypes.bool,
  showRatingNumber: PropTypes.bool,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
